import * as React from 'react'

import * as logger from '@owl-nest/logger'

import { trackingContext } from './context'
import { Context, PlausibleEvent, Track } from './types'
import { safePush } from './safePush'

type TrackingProviderProps = {
  context?: Context
  children: React.ReactNode
}

export function TrackingProvider({
  children,
  context,
}: TrackingProviderProps): React.ReactElement<TrackingProviderProps> {
  if (!context) {
    logger.warn('[shadow:plausible] No context provided')
  }

  return <trackingContext.Provider value={getTrack(context)}>{children}</trackingContext.Provider>
}

function getTrack(context?: string): Track {
  return (event: PlausibleEvent) => {
    const props = { ...event.props }
    if (context && !props.context) {
      props.context = context
    }

    safePush(event.type, { props, callback: event.callback })
  }
}

// define temporary plausible function queuing events before plausible script
// init.
if (typeof window !== 'undefined' && (window as any).plausible === undefined) {
  window.plausible = (...args) => {
    // we know `window.plausible` is defined, we are currently defining it.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const queue = (window.plausible!.q = window.plausible!.q ?? [])
    queue.push(args)
  }
}
